
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OrganizationUnitBasicInfoComponent = ({ onInnerFormChange, selectedOrganizationUnit, currencyCodeType, currencyRoundingType, timeZones }: any) => {

  return (
        <>
        <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'OrganizationUnitInfo.Name',
                  selectedOrganizationUnit?.OrganizationUnitInfo
                )
              }}
              type="text"
              value={selectedOrganizationUnit?.OrganizationUnitInfo?.Name}
          />
     <InputContainer
            label="Email"
            name="Email"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'OrganizationUnitInfo.Email',
                selectedOrganizationUnit?.OrganizationUnitInfo
              )
            }}
            type="text"
            value={selectedOrganizationUnit?.OrganizationUnitInfo?.Email}
        />
         <InputContainer
                label="PhoneNumber"
                name="PhoneNumber"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.PhoneNumber',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  )
                }}
                type="text"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.PhoneNumber}
            />
         <InputContainer
                isDisabled={selectedOrganizationUnit?.OrganizationUnitInfo?.Id}
                label="Currency Code"
                labelField="Text"
                list={currencyCodeType}
                onValueChange={(event: any, newValue: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.CurrencyCode',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  );
                }}
                optionName='Choose CurrencyCode'
                type="select"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.CurrencyCode}
                valueField="Text"
            />
         <InputContainer
                label="CurrencyRoundingType"
                labelField="Text"
                list={currencyRoundingType}
                onValueChange={(event: any, newValue: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.CurrencyRoundingTypeId',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  );
                }}
                optionName='Choose CurrencyRoundingType'
                type="select"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.CurrencyRoundingTypeId}
                valueField="Value"
            />
        <InputContainer
                label="CurrencyDecimalPlaces"
                name="CurrencyDecimalPlaces"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.CurrencyDecimalPlaces',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  )
                }}
                type="number"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.CurrencyDecimalPlaces}
            />
          <InputContainer
                label="TimeZone"
                labelField="TimeZoneDisplayName"
                list={timeZones}
                onValueChange={(event: any, newValue: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.TimeZone',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  );
                }}
                optionName='Choose TimeZone'
                type="select"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.TimeZone}
                valueField="TimeZoneId"
            />
         <InputContainer
                label="OrganizationUnit Vat"
                name="OrganizationUnit Vat"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.OrganizationUnitVat',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  )
                }}
                type="text"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.OrganizationUnitVat}
            />
         <InputContainer
                label="OrganizationUnit GST"
                name="OrganizationUnit GST"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.OrganizationUnitGST',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  )
                }}
                type="text"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.OrganizationUnitGST}
            />
          <InputContainer
                label="OrganizationUnit TIN"
                name="OrganizationUnit TIN"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event.target.value,
                    'OrganizationUnitInfo.OrganizationUnitTIN',
                    selectedOrganizationUnit?.OrganizationUnitInfo
                  )
                }}
                type="text"
                value={selectedOrganizationUnit?.OrganizationUnitInfo?.OrganizationUnitTIN}
            />
         <InputContainer
             label="Display Order"
             name="Display Order"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'OrganizationUnitInfo.DisplayOrder',
                 selectedOrganizationUnit?.OrganizationUnitInfo
               )
             }}
             type="number"
             value={selectedOrganizationUnit?.OrganizationUnitInfo?.DisplayOrder}
         />
         <div className='col-span-full'>
       <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'OrganizationUnitInfo.Description',
                  selectedOrganizationUnit?.OrganizationUnitInfo
                )
              }}
              type="text"
              value={selectedOrganizationUnit?.OrganizationUnitInfo?.Description}
          />
     </div></div>
      }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>
        </>
  )
}
export default OrganizationUnitBasicInfoComponent;
